import { GenericDiamond } from "./genericDiamond";
import { UploadFile } from "./misc";

export interface Product<TProductType> {
  id: number;
  product: TProductType;
  isActive: boolean;
}

enum DiamondStatusEnum {
  Available = 1,
  Hold = 2,
  Suspended = 3,
  Memo = 4,
}

enum MeleeColor {
  Black = 1,
  TTLB = 2,
  White = 3,
}

enum ProductType {
  Diamond = 1,
  Melee = 2,
  RingSetting = 3,
}

export interface ProductInterface {
  id: number;
  parcelName: string;
  quantity: number;
  status: string;
  cost: number;
  measurments: string;
  title: string;
  ringSize: number;
  repair: string;
  return: string;
  certPrice: number;
  totalPrice: number;
  labCertificate: string;
  certNum: string;
  type: string;
  subType: string;
  material: string;
  karatGold: string;
  colorOfGold: string;
  weight: number;
  mainStoneType: string;
  cutMainStone: string;
  numberOfMainStones: number;
  caratMainStone: number;
  colorMainStone: string;
  clarityMainStone: string;
  sideStoneType: string;
  cutSideStone: string;
  numberOfSideStones: number;
  caratOfSideStone: number;
  sideStoneColor: string;
  sideStoneClarity: string;
  secondSideStoneType: string;
  secondCutSideStone: string;
  secondNumberOfSideStones: number;
  secondCaratOfSideStone: number;
  secondSideStoneColor: string;
  secondSideStoneClarity: string;
  thirdSideStoneType: string;
  thirdCutSideStone: string;
  thirdNumberOfSideStones: number;
  thirdCaratOfSideStone: number;
  thirdSideStoneColor: string;
  thirdSideStoneClarity: string;
  forthSideStoneType: string;
  forthCutSideStone: string;
  forthNumberOfSideStones: number;
  forthCaratOfSideStone: number;
  forthSideStoneColor: string;
  forthSideStoneClarity: string;
  notes: string;
  brand: string;
  internalNotes: string;
  description: string;
  image1: string;
  image2: string;
  image3: string;
  image4: string;
  image5: string;
  image6: string;
  image7: string;
  image8: string;
  image9: string;
  image10: string;
  video: string;
  period: string;
  webPrice: string;
  soldFor: string;
  imageOrder: string;
  dateArrived: string;
  descriptionHE: string;
}

export const PRODUCT_FIELDS = [
  "parcelName", "quantity", "status", "cost", "measurments",
  "title", "ringSize", "repair", "return", "certPrice", "totalPrice",
  "labCertificate", "certNum", "type", "subType", "material", "karatGold",
  "colorOfGold", "weight", "mainStoneType", "period", "webPrice",
  "soldFor", "imageOrder", "dateArrived", "cutMainStone", "numberOfMainStones", "caratMainStone", "colorMainStone", "clarityMainStone",
  "sideStoneType", "cutSideStone", "numberOfSideStones", "caratOfSideStone", "sideStoneColor", "sideStoneClarity", "secondSideStoneType", "secondCutSideStone",
  "secondNumberOfSideStones", "secondCaratOfSideStone", "secondSideStoneColor", "secondSideStoneClarity", "thirdSideStoneType", "thirdCutSideStone",
  "thirdNumberOfSideStones", "thirdCaratOfSideStone", "thirdSideStoneColor", "thirdSideStoneClarity", "forthSideStoneType", "forthCutSideStone",
  "forthNumberOfSideStones", "forthCaratOfSideStone", "forthSideStoneColor", "forthSideStoneColor", "forthSideStoneClarity", "brand",
] as const;

export type ProductField = typeof PRODUCT_FIELDS[number];

export type Diamonds = {
  id: number;
  stockId: string;
  carats: number;
  color: string | MeleeColor;
  colorId: number;
  height: number;
  isActive: boolean;
  lab: string;
  labId: number;
  length: number;
  pricePerCarat: number;
  shape: string;
  shapeId: number;
  status: DiamondStatusEnum;
  totalPrice: number;
  width: number;
  isFancy: boolean;
  isMatchingPair: boolean;
  isMelee?: boolean;
  isNameDiamond?: boolean;
  letter?: string;
  size?: number;
  certificateNo?: string;
  certificateUrl?: string;
  clarity?: string;
  clarityId?: number;
  colorShade?: string;
  colorVariation?: string;
  comment?: string;
  crownAngle?: number;
  crownHeight?: number;
  culetSize?: number;
  cut?: string;
  cutId?: number;
  depthPercent?: number;
  discount?: number;
  eyeClean?: string;
  fancyIntensity?: string;
  fluor?: string;
  fluorId?: number;
  fluorescence?: string;
  fluorescenceColor?: string;
  girdle?: number;
  image3d?: string;
  set3D?: string;
  setImage?: string;
  imageUrl?: string;
  pic2?: string;
  pic3?: string;
  pic4?: string;
  isHighlighted?: boolean;
  milky?: string;
  overtone?: string;
  parcelStones?: number;
  pavilionAngle?: number;
  pavilionDepth?: number;
  polish?: string;
  polishId?: number;
  rapPrice: number;
  symmetry?: string;
  symmetryId?: number;
  tablePercent?: number;
  memoAccount?: string;
  memoPricePerCarat?: number;
  memoTotalPrice?: number;
  hold?: string;
  holdUserId?: string;
  memoNo?: number;
  memoDate?: string;
  memoRap?: number;
  isLine?: boolean;
  isSnP?: boolean;
  isLabGrown?: boolean;
  lineSet?: string;
  isPair?: boolean;
  wishListId?: number;
  tradeShow?: string;
  ringSize?: number;
  treatment?: string;
  showToAll?: string;
  lineSetColor?: string;
  lineSetClarity?: string;
  imageArray?: string[];
  vendor: string;
};


export interface MeleeStone {
  id: number;
  carats: number;
  color: MeleeColor;
  isActive: boolean;
  pricePerCarat: number;
  sizeFrom: number;
  sizeTo: number;
  quantity?: number;
}

export type UpsertMeleeStone = Omit<MeleeStone, "isActive" | "id">;
export interface RingSetting {
  id: number;
  name: string;
  sku: string;
  width: number;
  carat: number;
  origin: string;
  clarity: string;
  color: string;
  imageUrl?: string;
  price: number;
  goldType: string;
  style: string;
  shape: string;
  metalType: string;
  metalWeight: number;
  sideStones: number;
  quantity: number;
  threeStonesSideCt: number;
  hiddenDiamondBasket: string;
  image2?: string;
  image3?: string;
  image4?: string;
  image5?: string;
  image6?: string;
  video?: string;
  description?: string;
  active: boolean;
}

// export type UpsertRingSetting = Omit<RingSetting, "isActive" | "id">;

export interface EternityRing {
  id: number;
  sku: string;
  shape: string;
  ringSize: number;
  numberOfStones: number;
  weightPerStone: number;
  approxTotalCt: number;
  totalPrice: number;
  full: boolean;
  ringModel: string;
  goldColor: string;
  color: string;
  clarity: string;
  quantity: number;
  picture1: string;
  picture2: string;
  picture3: string;
  video: string;
  description?: string;
  active: boolean;
  [key: string]: string | number | boolean | undefined;
}

export type DiamondForBasket = {
  stockId: string;
  qty: number;
  shape: string;
  carats: number;
  colorName: string;
  clarityName: string;
  cutName: string;
  polName: string;
  symName: string;
  depth: number;
  table: number;
  measurement: string;
  pricePerCarat: number;
  discount: string;
  totalPrice: number;
  lab: string;
  certificate: string;
  image: string;
  image3d: string;
};

export type DiamondsType = {
  id: number;
  stockId: string;
  carats: number;
  certificateNo?: string;
  certificateUrl?: string;
  clarityId?: number;
  colorId: number | MeleeColor;
  colorShade?: string;
  comment?: string;
  crownAngle?: number;
  crownHeight?: number;
  culetSize?: number;
  cutId?: number;
  depthPercent?: number;
  discount?: number;
  eyeClean?: string;
  fancyIntensity?: string;
  fluorId?: number;
  fluorescence?: string;
  fluorescenceColor?: string;
  girdle?: number;
  height: number;
  image3d?: string;
  set3D?: string;
  setImage?: string;
  imageUrl?: string;
  pic2?: string;
  pic3?: string;
  pic4?: string;
  isHighlighted?: boolean;
  labId: number;
  length: number;
  milky?: string;
  overtone?: string;
  parcelStones?: number;
  pavilionAngle?: number;
  pavilionDepth?: number;
  polishId?: number;
  pricePerCarat: number;
  rapPrice?: number;
  shapeId: number;
  status: DiamondStatusEnum;
  symmetryId?: number;
  tablePercent?: number;
  totalPrice: number;
  width: number;
  isMatchingPair: boolean;
  memoAccount?: string;
  memoPricePerCarat?: number;
  memoTotalPrice?: number;
  hold?: string;
  holdUserId?: string;
  memoNo?: number;
  memoDate?: string;
  memoRap?: number;
  isLine?: boolean;
  isLabGrown?: boolean;
  isSnP?: boolean;
  lineSet?: string;
  isPair?: boolean;
  wishListId?: number;
  tradeShow?: string;
  ringSize?: number;
  treatment?: string;
  showToAll?: string;
  lineSetColor?: string;
  lineSetClarity?: string;
  imageArray?: string[];
  vendor: string;
};

export type Diamond = {
  id: number;
  stockId: string;
  carats: number;
  color: string | MeleeColor;
  colorId: number;
  height: number;
  isActive: boolean;
  lab: string;
  labId: number;
  length: number;
  pricePerCarat: number;
  shape: string;
  shapeId: number;
  status: DiamondStatusEnum;
  totalPrice: number;
  width: number;
  isFancy: boolean;
  isMatchingPair: boolean;
  isMelee?: boolean;
  certificateNumber?: string;
  certificateUrl?: string;
  clarity?: string;
  clarityId?: number;
  colorShade?: string;
  colorVariation?: string;
  comment?: string;
  crownAngle?: number;
  crownHeight?: number;
  culetSize?: number;
  cut?: string;
  cutId?: number;
  depthPercent?: number;
  discount?: number;
  eyeClean?: string;
  fancyIntensity?: string;
  fluor?: string;
  fluorId?: number;
  fluorescence?: string;
  fluorescenceColor?: string;
  girdle?: number;
  image3d?: string;
  set3D?: string;
  setImage?: string;
  imageUrl?: string;
  pic2?: string;
  pic3?: string;
  pic4?: string;
  isHighlighted?: boolean;
  milky?: string;
  overtone?: string;
  parcelStones?: number;
  pavilionAngle?: number;
  pavilionDepth?: number;
  polish?: string;
  polishId?: number;
  rapPrice: number;
  symmetry?: string;
  symmetryId?: number;
  tablePercent?: number;
  memoAccount?: string;
  memoPricePerCarat?: number;
  memoTotalPrice?: number;
  hold?: string;
  holdUserId?: string;
  memoNo?: number;
  memoDate?: string;
  memoRap?: number;
  isLine?: boolean;
  isSnP?: boolean;
  isLabGrown?: boolean;
  lineSet?: string;
  isPair?: boolean;
  wishListId?: number;
  tradeShow?: string;
  ringSize?: number;
  treatment?: string;
  showToAll?: string;
  lineSetColor?: string;
  lineSetClarity?: string;
  imageArray?: string[];
  vendor: string;
};

//FIX ID ENGAGEMENT
export interface DiamondAndRing {
  id: number;
  type?: string;
  wishListId: number;
  completedRingId?: number;
  engagementRingId?: number;
  diamond?: Diamond;
  ringSetting?: RingSetting;
  genericDiamond?: GenericDiamond;
  ring?: EternityRing;
}

export type ExcludeProps =
  | "id"
  | "imageUrl"
  | "clarity"
  | "color"
  | "cut"
  | "fluor"
  | "lab"
  | "polish"
  | "shape"
  | "symmetry"
  | "isActive"
  | "status"
  | "totalPrice";

export type ExcludeRingProps = "isActive" | "id" | "imageUrl";

export type UpsertDiamondModel = Omit<Diamonds, ExcludeProps> & {
  image?: UploadFile;
};
export type UpsertRingSetting = Omit<RingSetting, ExcludeRingProps> & {
  image?: UploadFile;
};

export interface UpsertProduct {
  id: number;
  parcelName: string;
  quantity: number;
  status: string;
  cost: number | null;
  measurments: string;
  title: string;
  ringSize: number | null;
  repair: number | null;
  return: number | null;
  certPrice: number | null;
  totalPrice: number; 
  labCertificate: string;
  certNum: string;
  type: string;
  subType: string;
  material: string;
  karatGold: string;
  colorOfGold: string;
  weight: number;
  mainStoneType: string;
  cutMainStone: string;
  numberOfMainStones: number | null;
  caratMainStone: number | null;
  colorMainStone: string;
  clarityMainStone: string;
  sideStoneType: string;
  cutSideStone: string;
  numberOfSideStones: number | null;
  caratOfSideStone: number | null;
  sideStoneColor: string;
  sideStoneClarity: string;
  secondSideStoneType: string;
  secondCutSideStone: string;
  secondNumberOfSideStones: number | null;
  secondCaratOfSideStone: number | null;
  secondSideStoneColor: string;
  secondSideStoneClarity: string;
  thirdSideStoneType: string;
  thirdCutSideStone: string;
  thirdNumberOfSideStones: number | null;
  thirdCaratOfSideStone: number | null;
  thirdSideStoneColor: string;
  thirdSideStoneClarity: string;
  forthSideStoneType: string;
  forthCutSideStone: string;
  forthNumberOfSideStones: number | null;
  forthCaratOfSideStone: number | null;
  forthSideStoneColor: string;
  forthSideStoneClarity: string;
  notes: string;
  brand: string;
  internalNotes: string;
  description: string; 
  image1: UploadFile | string | undefined; 
  image2: UploadFile | string | undefined;
  image3: UploadFile | string | undefined;
  image4: UploadFile | string | undefined;
  image5: UploadFile | string | undefined;
  image6: UploadFile | string | undefined;
  image7: UploadFile | string | undefined;
  image8: UploadFile | string | undefined;
  image9: UploadFile | string | undefined;
  image10: UploadFile | string | undefined;
  video: UploadFile | string | undefined;
  period: string;
  webPrice: string;
  soldFor: string;
  imageOrder?: string;
  descriptionHE: string;
}

export type UpsertProductPayload = Partial<UpsertProduct>;


export type UpsertOrderInvoiceModel = {
  invoice?: UploadFile;
  orderId: number;
  userEmail: string | undefined;
  ccEmail?: string;
  title: string;
  description?: string;
};

export { DiamondStatusEnum, MeleeColor, ProductType };
